export const BlankAbility = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAIAAAADehTSAAAAR0lEQVRo3u3OAQkAQAgEMDXI9Y/5KUQetgTrJPWJuQ64nnN1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV13fEAJIYAzN96k+EAAAAASUVORK5CYII=";

export const MeleeAbilities: string[] = [
  "https://img.pvme.io/images/FLBzCBbLxz.webp", //melee basic
  "https://img.pvme.io/images/OKgWLQZr6u.webp", //adaptive strike
  "https://cdn.discordapp.com/emojis/535532879820619786.png", //rend
  "https://cdn.discordapp.com/emojis/535532879510372352.png", //fury
  "https://cdn.discordapp.com/emojis/535532879334080527.png", //greater fury
  "https://cdn.discordapp.com/emojis/535532854302605333.png", //backhand
  "https://cdn.discordapp.com/emojis/867678153854025779.png", //backhand flanking
  "https://cdn.discordapp.com/emojis/535532879439069184.png", //punish
  "https://cdn.discordapp.com/emojis/535532853916860437.png", //barge
  "https://cdn.discordapp.com/emojis/535532879250456578.png", //greater barge
  "https://img.pvme.io/images/SBxKhzUNKE.webp", //chaos roar
  "https://cdn.discordapp.com/emojis/535532855191928842.png", //assault
  "https://cdn.discordapp.com/emojis/535532878969438210.png", //hurricane
  "https://cdn.discordapp.com/emojis/864492981763702834.png", //flurry
  "https://cdn.discordapp.com/emojis/535532879283879977.png", //greater flurry
  "https://img.pvme.io/images/qPRMFCsp23.webp", //dismember
  "https://cdn.discordapp.com/emojis/535532879334080517.png", //overpower
  "https://cdn.discordapp.com/emojis/959089455640215633.png", //igneous overpower
  "https://cdn.discordapp.com/emojis/535532879053062146.png", //pulverise
  "https://cdn.discordapp.com/emojis/535532854004678657.png", //berserk
  "https://img.pvme.io/images/81HMxObool.webp", //meteor strike
  "https://cdn.discordapp.com/emojis/1049378668197195808.png", //dive
  "https://cdn.discordapp.com/emojis/535532854281764884.png", //bladed dive 
];

export const RangeAbilities: string[] = [
  "https://img.pvme.io/images/HAc5xYqGUV.webp", //ranged basic
  "https://img.pvme.io/images/y8dBjmQZSJ.webp", //piercing shot
  //need updated"https://cdn.discordapp.com/emojis/867678153979854868.png", //piercing energising
  "https://cdn.discordapp.com/emojis/535541306563231790.png", //binding shot
  "https://cdn.discordapp.com/emojis/867678153400647701.png", //binding shot flanking
  "https://img.pvme.io/images/YeiRAAxXYB.webp", //imbue gale
  "https://img.pvme.io/images/hQduTi7o4o.webp", //ricochet
  //need updated"https://cdn.discordapp.com/emojis/867678153635004447.png", //ricochet caroming
  "https://cdn.discordapp.com/emojis/787904334812807238.png", //greater ricochet
  "https://cdn.discordapp.com/emojis/867678153966878740.png", //greater ricochet caroming
  "https://img.pvme.io/images/WHTscLhdbk.webp", //snapshot
  "https://img.pvme.io/images/ouNQwWo9MM.webp", //snipe
  "https://cdn.discordapp.com/emojis/535541306391265284.png", //bombardment
  "https://cdn.discordapp.com/emojis/535541270521708566.png", //rapid fire
  "https://cdn.discordapp.com/emojis/642713547142332416.png", //shadow tendrils
  "https://cdn.discordapp.com/emojis/535541306294796299.png", //corruption shot
  "https://img.pvme.io/images/INpvAsW5Jc.webp", //imbue shadows
  "https://img.pvme.io/images/LLYuG5lgRv.webp", //deadshot
  //need updated"https://cdn.discordapp.com/emojis/959089455283728386.png", //igneous deadshot
  "https://img.pvme.io/images/M35wETJU2P.webp", //deaths swiftness
  "https://cdn.discordapp.com/emojis/994644354536837121.png", //greater death swiftness
  "https://cdn.discordapp.com/emojis/535541258832052231.png", //escape
];

export const MageAbilities: string[] = [
  "https://img.pvme.io/images/a51JSKPdfz.webp", //magic basic
 "https://img.pvme.io/images/Ct4XTMUwZZ.webp", //sonic wave
 "https://img.pvme.io/images/zxtNbofl8y.webp", //greater sonic wave
 "https://cdn.discordapp.com/emojis/535533833391702017.png", //dragon breath
 "https://cdn.discordapp.com/emojis/535533809655873556.png", //impact
 "https://cdn.discordapp.com/emojis/867678154369400862.png", //impact flanking
 "https://img.pvme.io/images/W5h1lGupxA.webp", //combust
 //need updated"https://cdn.discordapp.com/emojis/867678153992437790.png", //combust lunging
 "https://img.pvme.io/images/82PXXSsEWB.webp", //chain
 "https://cdn.discordapp.com/emojis/867678153962684426.png", //chain caroming
 "https://img.pvme.io/images/0w0DrNzSRH.webp", //greater chain
 "https://cdn.discordapp.com/emojis/867678153882861568.png", //greater chain caroming
 "https://img.pvme.io/images/qcvRxP2Sy7.webp", //concentrated blast
 "https://img.pvme.io/images/vQl3485ZuQ.webp", //greater concentrated blast
 "https://cdn.discordapp.com/emojis/535533809978966037.png", //wild magic
 "https://cdn.discordapp.com/emojis/535533833072672778.png", //asphyxiate
 "https://cdn.discordapp.com/emojis/536257336130404372.png", //smoke tendrils
 "https://cdn.discordapp.com/emojis/924741973858996284.png", //magma tempest targeted
 "https://cdn.discordapp.com/emojis/902209626509025290.png", //magma tempest
 "https://img.pvme.io/images/JkOw1LoeZj.webp", //corruption blast
 "https://cdn.discordapp.com/emojis/535533809664262179.png", //omnipower
 "https://cdn.discordapp.com/emojis/1179505745654448208.png", //igneous omnipower
 "https://cdn.discordapp.com/emojis/994921119381463070.png", //sunshine
 "https://cdn.discordapp.com/emojis/994644352871714836.png", //greater sunshine
 "https://cdn.discordapp.com/emojis/535533809995874304.png", //tsunami
 "https://cdn.discordapp.com/emojis/958989794757730307.png", //tsunami incite
 "https://cdn.discordapp.com/emojis/799457167182659586.png", //surge
 "https://img.pvme.io/images/9hZoj9PK9n.webp", //runic charge
];

export const NecromancyAbilities: string[] = [
  "https://cdn.discordapp.com/emojis/1137809137401602109.png", //necromancy
  "https://cdn.discordapp.com/emojis/1159434516658651147.png", //conjure skeleton warrior
  "https://cdn.discordapp.com/emojis/1159434801938432010.png", //finger of death
  "https://cdn.discordapp.com/emojis/1137809175980810380.png", //touch of death
  "https://cdn.discordapp.com/emojis/1159434663903899728.png", //death skulls
  "https://cdn.discordapp.com/emojis/1179505729367969863.png", //igneous death skulls
  "https://cdn.discordapp.com/emojis/1159434279311380532.png", //blood siphon
  "https://cdn.discordapp.com/emojis/1137809200219684924.png", //conjure zombie
  "https://cdn.discordapp.com/emojis/1137809206423060632.png", //conjure ghost vengeful
  "https://cdn.discordapp.com/emojis/1159433682403201044.png", //bloat
  "https://cdn.discordapp.com/emojis/1137809140476031057.png", //soul sap
  "https://cdn.discordapp.com/emojis/1137809142376058910.png", //soul strike
  "https://cdn.discordapp.com/emojis/1156683164593430579.png", //soul strike flanking
  "https://cdn.discordapp.com/emojis/1137809145706319892.png", //spectral scythe
  "https://cdn.discordapp.com/emojis/1159435029592686642.png", //volley of souls
  "https://cdn.discordapp.com/emojis/1280109199069806604.png", //conjure phantom guardian
  "https://cdn.discordapp.com/emojis/1159434908486357072.png", //living death
  "https://cdn.discordapp.com/emojis/1166094935066423348.png" //conjure army
]

export const NecromancyIncantations: string[] = [
  "https://cdn.discordapp.com/emojis/1137809125590450276.png", //lesser bone shield
  "https://cdn.discordapp.com/emojis/1137809172335951933.png", //threads of fate
  "https://cdn.discordapp.com/emojis/1137809118283976814.png", //greater bone shield
  "https://cdn.discordapp.com/emojis/1137809128136388819.png", //life transfer
  "https://cdn.discordapp.com/emojis/1176968330582700174.png", //invoke lord of bones
  "https://cdn.discordapp.com/emojis/1137809121983336548.png", //invoke death
  "https://cdn.discordapp.com/emojis/1137809209782698024.png", //darkness
  "https://cdn.discordapp.com/emojis/1137809168368148490.png", //split soul
]

export const DefensiveAbilities: string[] = [
 "https://cdn.discordapp.com/emojis/513190158728953857.png", //devotion
 "https://img.pvme.io/images/urJ4nkOcNi.png", //unsullied sigil
 "https://cdn.discordapp.com/emojis/909338509234569216.png", //aggression sigil
 "https://cdn.discordapp.com/emojis/864235458464186418.png", //cease
 "https://cdn.discordapp.com/emojis/535541306475151390.png", //anticipate
 "https://cdn.discordapp.com/emojis/867678154071998464.png", //anticipate clear headed
 "https://cdn.discordapp.com/emojis/998692900135252078.png", //anticipate reflexes
 "https://cdn.discordapp.com/emojis/535541306546716692.png", //bash
 "https://cdn.discordapp.com/emojis/535541259645878302.png", //revenge
 "https://cdn.discordapp.com/emojis/535541259465392143.png", //provoke
 "https://cdn.discordapp.com/emojis/535541258538582017.png", //immortality
 "https://cdn.discordapp.com/emojis/535541258240786434.png", //freedom
 "https://cdn.discordapp.com/emojis/535541258786177064.png", //reflect
 "https://cdn.discordapp.com/emojis/535541258844635148.png", //resonance
 "https://cdn.discordapp.com/emojis/787904334377648130.png", //divert
 "https://cdn.discordapp.com/emojis/535541258873995284.png", //rejuvenate
 "https://cdn.discordapp.com/emojis/535541278264393729.png", //debilitate
 "https://cdn.discordapp.com/emojis/535541258546970624.png", //preparation
 "https://cdn.discordapp.com/emojis/535541306353778689.png", //barricade
 "https://cdn.discordapp.com/emojis/867678153883516958.png", //barricade turtling
 "https://cdn.discordapp.com/emojis/535541258131865633.png", //natural instinct
];

export const ConstitutionAbilities: string[] = [
  "https://cdn.discordapp.com/emojis/1073883122069934182.png", //eat food
  "https://cdn.discordapp.com/emojis/1137770309315997836.png", //regenerate
  "https://cdn.discordapp.com/emojis/513201065907322880.png", //sacrifice
  "https://cdn.discordapp.com/emojis/553050196523876354.png", //transfigure
  "https://cdn.discordapp.com/emojis/537340400273195028.png", //weapon special attack
  "https://cdn.discordapp.com/emojis/641339234111848463.png", //ingenuity of the humans sigil
  "https://cdn.discordapp.com/emojis/641339921675845633.png", //demon slayer sigil
  "https://cdn.discordapp.com/emojis/641339921814126594.png", //dragon slayer sigil
  "https://cdn.discordapp.com/emojis/641339922019516416.png", //undead slayer sigil
  "https://cdn.discordapp.com/emojis/641339233638023179.png", //limitless sigil
  "https://img.pvme.io/images/4w06xbygZg.png", //slayer's insight sigil
  "https://img.pvme.io/images/ANesID4R2c.png", //kuradal's favour sigil
  "https://cdn.discordapp.com/emojis/1257438999794946099.png", //eof ability special attack
  "https://cdn.discordapp.com/emojis/553050198012854275.png", //siphon
  "https://cdn.discordapp.com/emojis/553050196725071893.png", //incite
  "https://cdn.discordapp.com/emojis/513201065513058306.png", //tuskas wrath
  "https://cdn.discordapp.com/emojis/536256663641128971.png", //storm shards
  "https://cdn.discordapp.com/emojis/536256673904328704.png", //shatter
  "https://cdn.discordapp.com/emojis/553050196767145995.png", //guthix butterflies
  "https://cdn.discordapp.com/emojis/513190159462694912.png", //reprisal
  "https://cdn.discordapp.com/emojis/513190159085207555.png", //onslaught
  "https://cdn.discordapp.com/emojis/553050196817215491.png", //ice asylum
];
